import React from 'react';
interface Props {
  fillColor?: string;
}

function LungIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none">
      <g clipPath="url(#clip0_851_3338)">
        <path
          d="M10.75 1.10547C10.75 0.689844 10.4156 0.355469 10 0.355469C9.58438 0.355469 9.25 0.689844 9.25 1.10547V5.56797C9.25 6.13359 8.97812 6.66484 8.51562 6.99297L8 7.36172V6.12734V5.85547V5.52109C8 4.32422 7.03125 3.35547 5.83437 3.35547C5.15625 3.35547 4.49687 3.67422 4.09062 4.25547C3.60937 4.94609 2.70625 6.29922 1.87188 7.90859C1.04375 9.49922 0.234375 11.4242 0.00625 13.2305C0 13.2711 0 13.3117 0 13.3555V13.5742C0 15.1086 1.24375 16.3555 2.78125 16.3555C3.00938 16.3555 3.23438 16.3273 3.45625 16.2711L5.72813 15.7023C7.0625 15.3711 8 14.1711 8 12.793V10.4336L6.5 11.5055V12.793C6.5 13.4805 6.03125 14.0805 5.3625 14.2492L3.09063 14.818C2.9875 14.843 2.88438 14.8555 2.78125 14.8555C2.075 14.8555 1.5 14.2836 1.5 13.5742V13.3867C1.69687 11.8523 2.40625 10.1305 3.2 8.60234C3.99688 7.07109 4.85938 5.77422 5.31875 5.11484C5.43125 4.95547 5.61875 4.85547 5.83125 4.85547C6.2 4.85547 6.49687 5.15547 6.49687 5.52109V5.85547V7.20547V8.43359L4.3125 9.99609C3.975 10.2367 3.89687 10.7055 4.1375 11.043C4.37812 11.3805 4.84687 11.4586 5.18437 11.218L6.5 10.2805L8 9.20859L9.3875 8.21797C9.61875 8.05234 9.82187 7.86172 10 7.64922C10.175 7.86172 10.3813 8.05234 10.6125 8.21797L12 9.20547L13.5 10.2773L14.8156 11.2148C15.1531 11.4555 15.6219 11.3773 15.8625 11.0398C16.1031 10.7023 16.025 10.2336 15.6875 9.99297L13.5031 8.43047V7.20234V5.85234V5.51797C13.5031 5.14922 13.8031 4.85234 14.1687 4.85234C14.3812 4.85234 14.5687 4.95234 14.6812 5.11172C15.1406 5.77109 16.0031 7.06797 16.8 8.59922C17.5938 10.1305 18.3031 11.8523 18.5 13.3867V13.5742C18.5 14.2805 17.9281 14.8555 17.2188 14.8555C17.1125 14.8555 17.0094 14.843 16.9094 14.818L14.6375 14.2492C13.9688 14.0836 13.5 13.4836 13.5 12.793V11.5055L12 10.4336V12.793C12 14.1711 12.9375 15.3711 14.2719 15.7023L16.5438 16.2711C16.7656 16.3273 16.9906 16.3555 17.2188 16.3555C18.7531 16.3555 20 15.1117 20 13.5742V13.3555C20 13.3148 19.9969 13.2711 19.9937 13.2305C19.7687 11.4211 18.9594 9.49922 18.1313 7.90859C17.2938 6.29922 16.3938 4.94609 15.9125 4.25547C15.5063 3.67422 14.85 3.35547 14.1687 3.35547C12.9688 3.35547 12 4.32422 12 5.52109V5.85547V6.12734V7.36172L11.4812 6.99297C11.0219 6.66484 10.75 6.13359 10.75 5.56797V1.10547Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3338">
          <rect
            width="20"
            height="16"
            fill="white"
            transform="translate(0 0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default LungIcon;
